// Garrett Park Guitars — Gibson Serial Lookup (Option D: store-native UI)
// Full replacement for assets/gibson-lookup.js

console.log("Gibson lookup loaded from Assets! (Option D UI)");

(function () {
  // --- Utilities ---
  function normalize(sn) {
    if (!sn) return '';
    return sn.toUpperCase().replace(/[^A-Z0-9]/g, '');
  }
  function escapeHtml(str) {
    if (str == null) return '';
    return String(str).replace(/[&<>"'`=\/]/g, function (s) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;','/':'&#x2F;','`':'&#x60;','=':'&#x3D;'})[s];
    });
  }

  // --- Parsers (YYDDDNNN and YDDDYRRR) ---
  function tryParseYYDDDNNN(sn) {
    if (!/^[0-9]{8}$/.test(sn)) return null;
    const yy = parseInt(sn.slice(0,2),10);
    const ddd = parseInt(sn.slice(2,5),10);
    const seq = sn.slice(5);
    if (isNaN(yy) || isNaN(ddd) || ddd < 1 || ddd > 366) return null;
    const now = new Date();
    const current2 = now.getFullYear() % 100;
    const yearFull = (yy <= current2) ? 2000 + yy : 1900 + yy;
    const jan1 = new Date(yearFull,0,1);
    const target = new Date(jan1.getTime() + (ddd - 1) * 86400000);
    if (target.getFullYear() !== yearFull) return null;
    const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const friendly = `${monthNames[target.getMonth()]} ${target.getDate()}, ${yearFull}`;
    return {
      label: `${friendly} (day ${String(ddd).padStart(3,'0')} of ${yearFull})`,
      confidence: 'medium',
      why: `Serial parsed as YYDDDNNN: YY=${String(yy).padStart(2,'0')} → ${yearFull}, DDD=${String(ddd)} → ${friendly}, sequence=${seq}.`
    };
  }

  function tryParseYDDDYRRR(sn) {
    if (!/^[0-9]{8}$/.test(sn)) return null;
    const y1 = parseInt(sn.charAt(0),10);
    const ddd = parseInt(sn.slice(1,4),10);
    const y2 = parseInt(sn.charAt(4),10);
    const seq = sn.slice(5);
    if (isNaN(y1) || isNaN(ddd) || isNaN(y2) || ddd < 1 || ddd > 366) return null;

    const now = new Date();
    const currentYear = now.getFullYear();
    const candidateYears = [];
    for (let y = 1977; y <= currentYear; y++) {
      if (y % 10 === y1) candidateYears.push(y);
    }
    if (candidateYears.length === 0) {
      for (let base = 1970; base <= 2020; base += 10) candidateYears.push(base + y1);
    }
    const parsedCandidates = [];
    const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    candidateYears.forEach(yearFull => {
      const jan1 = new Date(yearFull,0,1);
      const target = new Date(jan1.getTime() + (ddd - 1) * 86400000);
      if (target.getFullYear() === yearFull) {
        parsedCandidates.push({
          year: yearFull,
          dateFriendly: `${monthNames[target.getMonth()]} ${target.getDate()}, ${yearFull}`,
          seq: seq
        });
      }
    });
    if (parsedCandidates.length === 0) return null;

    // Determine best candidate: prefer matching y1===y2; else prefer most recent; made-in-usa preference for 1970s
    let madeInUSA = false;
    try { const cb=document.getElementById('gibson-madeinusa'); if (cb && cb.checked) madeInUSA=true; } catch(e){}
    let bestCandidate = parsedCandidates[parsedCandidates.length-1];
    if (madeInUSA) {
      const seventies = parsedCandidates.find(c => c.year >= 1970 && c.year < 1980);
      if (seventies) bestCandidate = seventies;
    }
    if (y1 === y2) {
      // If there's a candidate that matches the same decade for both positions (they are same digit) prefer earliest such candidate
      const matched = parsedCandidates.find(c => (c.year % 10) === y2);
      if (matched) bestCandidate = matched;
    }

    const confidence = (y1 === y2) ? 'high' : 'medium';

    const best = {
      label: `${bestCandidate.dateFriendly} (seq ${bestCandidate.seq})`,
      confidence: (confidence === 'high' ? 'high' : 'medium'),
      why: `Parsed as YDDDYRRR: Y=${y1}, DDD=${String(ddd).padStart(3,'0')} → ${bestCandidate.dateFriendly}, sequence=${bestCandidate.seq}. ${y1===y2? 'Year digits match (good signal).':''}`
    };

    const others = parsedCandidates
      .filter(c => c.year !== bestCandidate.year)
      .map(c => ({
        label: `${c.dateFriendly} (seq ${c.seq})`,
        confidence: 'low',
        why: `Alternate possibility: last-digit match → ${c.year}. Validate using pots/headstock.`
      }));

    return { best: best, others: others, yMatch: (y1===y2), raw: parsedCandidates };
  }

  // --- Core lookup logic (keeps prior heuristics) ---
  function lookupGibsonSerialLogic(rawInput) {
    const raw = (rawInput || '').trim();
    const sn = normalize(raw);
    const candidates = [];
    if (!sn) return [{label:'No serial provided', confidence:'low', why:'Please enter a serial.'}];

    if (sn.length === 5 && /^[0-9]{5}$/.test(sn)) {
      const first = parseInt(sn.charAt(0),10);
      if (!isNaN(first)) {
        const likelyYear = 1950 + first;
        candidates.push({label:`${likelyYear}`, confidence:'medium', why:`Short 5-digit stamp — first digit (${first}) often indicates the last digit of the year for many 1950s Gibson solidbody stamps.`});
        candidates.push({label:`${likelyYear-10}–${likelyYear+1}`, confidence:'low', why:'Short stamps sometimes appear into early 1960s — check pot codes and logo style.'});
        return candidates;
      }
    }

    if (sn.length === 4 && /^[0-9]{4}$/.test(sn)) {
      candidates.push({label:'Likely 1940s–1950s (low confidence)', confidence:'low', why:'Four-digit numbers are uncommon but can appear on certain ink-stamped parts.'});
      return candidates;
    }

    if (sn.length === 6 && /^[0-9]{6}$/.test(sn)) {
      let madeInUSA=false;
      try{ const cb=document.getElementById('gibson-madeinusa'); if(cb&&cb.checked) madeInUSA=true;}catch(e){}
      if(madeInUSA) {
        candidates.push({label:'1970–1975', confidence:'high', why:'6-digit serial + "Made in USA" stamp is a strong early-1970s indicator.'});
      } else {
        candidates.push({label:'1961–1969 (possible) or 1970s reused block', confidence:'medium', why:'6-digit impressed serials were common in 1960s; ranges were reused in 1970s — check for Made in USA & pot codes.'});
        candidates.push({label:'If "Made in USA" present → 1970–1975', confidence:'low', why:'Toggle the Made in USA checkbox if present.'});
      }
      return candidates;
    }

    // 8-digit: try YYDDDNNN -> then YDDDYRRR
    if (sn.length === 8 && /^[0-9]{8}$/.test(sn)) {
      const parsedYY = tryParseYYDDDNNN(sn);
      if (parsedYY) return [parsedYY];

      const parsedY = tryParseYDDDYRRR(sn);
      if (parsedY) {
        const arr = [];
        arr.push(parsedY.best);
        parsedY.others.forEach(o=>arr.push(o));
        if (!parsedY.yMatch) arr.push({label:'Digit mismatch note', confidence:'low', why:'The two single-digit year spots do not match — cross-check physical cues.'});
        return arr;
      }

      candidates.push({label:'1975–present (8-digit systems)', confidence:'medium', why:'8-digit serials often indicate later Gibson systems; precise decode may require context.'});
      return candidates;
    }

    if (sn.length >=7 && sn.length <=9 && /^[0-9]+$/.test(sn)) {
      const parsed = tryParseYYDDDNNN(sn.padStart(8,'0'));
      if(parsed) return [parsed];
      candidates.push({label:'1975–present (modern multi-digit systems)', confidence:'medium', why:'Long numeric strings are part of later numbering systems.'});
      return candidates;
    }

    if (/^[A-Z][0-9]+$/.test(sn)) {
      candidates.push({label:'Alphanumeric serial (model/factory-specific)', confidence:'low', why:'Alphanumeric prefixes often require model-level context.'});
      if (sn.length === 5) {
        const numericPart = sn.slice(1);
        if (/^[0-9]{4}$/.test(numericPart)) candidates.push({label:'Possibly 1950s-style short stamp (check physical cues)', confidence:'low', why:'Verify headstock & pot codes.'});
      }
      return candidates;
    }

    candidates.push({label:'Unknown or ambiguous format', confidence:'low', why:'The serial did not match quick-decode patterns. Check headstock, pot codes, and photos.'});
    return candidates;
  }

  // --- UI formatting & helpers ---
  function buildCompactHeader(candidates) {
    if (!Array.isArray(candidates) || candidates.length===0) return '';
    const best = candidates[0];
    const others = candidates.slice(1);
    const badge = `<span class="gpg-badge">${escapeHtml(best.confidence.toUpperCase())}</span>`;
    const otherList = others.length ? `<div class="gpg-others">Other: ${others.map(o=>escapeHtml((o.label.match(/\d{4}/)||[o.label])[0]||o.label)).join(', ')}</div>` : '';
    return `<div class="gpg-compact" role="region" aria-label="Best guess">
      <div class="gpg-compact-left">
        <div class="gpg-best">${escapeHtml(best.label)}</div>
        ${otherList}
      </div>
      <div style="display:flex;gap:8px;align-items:center">
        ${badge}
        <button class="gpg-details-toggle" type="button" aria-expanded="false">Show details</button>
      </div>
    </div>`;
  }

  function formatCandidatesHTML(candidates) {
    if (!Array.isArray(candidates) || candidates.length === 0) return '<div><strong>No result</strong></div>';

    // Build header
    let html = '<div>';
    html += buildCompactHeader(candidates);

    // Collapsible details container
    html += `<div class="gpg-collapse" id="gpg-collapse">`;

    candidates.forEach(c => {
      html += `<div class="gpg-candidate"><strong>${escapeHtml(c.label)}</strong><div class="gpg-why">${escapeHtml(c.why)}</div></div>`;
    });

    html += `</div>`; // close collapse
    // Next steps
    html += `<div style="margin-top:8px;padding-top:8px;border-top:1px dashed rgba(0,0,0,0.06);color:rgba(0,0,0,0.7)">
      <strong>Next steps to improve accuracy</strong>
      <ul style="margin:8px 0 0 18px;">
        <li>Look for a <em>"Made in USA"</em> stamp beneath the headstock serial — this boosts early-1970s confidence.</li>
        <li>Check potentiometer date codes inside the control cavity — they often resolve reused ranges.</li>
        <li>Is the serial <em>impressed</em> into the wood or a decal/ink? Impressed numbers were common in many eras.</li>
        <li>Compare headstock logo style and hardware to known examples.</li>
      </ul></div>`;

    html += '</div>'; // outer
    return html;
  }

  // --- DOM hookup ---
  document.addEventListener("DOMContentLoaded", function () {
    const input = document.getElementById('gibson-serial-input');
    const btn = document.getElementById('gibsonLookupBtn');
    const resultBox = document.getElementById('gibson-lookup-result');
    if (!input || !btn || !resultBox) { console.error('Gibson lookup: required elements missing.'); return; }

    function showHtml(html) {
      resultBox.style.display = 'block';
      resultBox.innerHTML = html;
      // hook toggle
      const toggle = resultBox.querySelector('.gpg-details-toggle');
      const collapse = resultBox.querySelector('#gpg-collapse');
      if (toggle && collapse) {
        toggle.addEventListener('click', function () {
          const open = collapse.classList.toggle('open');
          toggle.textContent = open ? 'Hide details' : 'Show details';
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
    }

    function runLookup() {
      const raw = input.value || '';
      if (!raw.trim()) {
        showHtml('<div style="color:#b00"><strong>Please enter a serial number.</strong></div>');
        return;
      }
      const candidates = lookupGibsonSerialLogic(raw);
      const html = formatCandidatesHTML(candidates);
      showHtml(html);
    }

    input.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); runLookup(); }});
    btn.addEventListener('click', runLookup);
  });

})(); // end closure
